/**
 * @name doc_node
 */

export const doc = {
  content: '(block|layoutSection|blockRootOnly)+',
  marks: 'alignment breakout dataConsumer fragment indentation unsupportedMark unsupportedNodeAttribute'
};